import React from "react";
import { Sparkles, Users, ShieldCheck, Rocket } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";

const SECTIONS = [
  { icon: Sparkles, title: "What Ishukart is", points: [
    "Ishukart is an AI app builder. You describe the website or web app you want in plain words, and our AI writes the code, shows you a live preview and keeps improving it as you chat.",
    "Every change is saved as a version, so you can always look back, compare and restore.",
  ] },
  { icon: Users, title: "Who it's for", points: [
    "Small business owners, creators, students and freelancers who want a real website or tool without hiring a developer.",
    "Developers who want a fast starting point — download the code or push it straight to GitHub.",
  ] },
  { icon: Rocket, title: "How you ship", points: [
    "Publish to your own address on Ishukart in one click, connect a custom domain, or take the code anywhere.",
    "Buy credit packs only when you need them — paid credits never expire.",
  ] },
  { icon: ShieldCheck, title: "Our promise", points: [
    "Your projects belong to you. You can download or delete them at any time.",
    "Payments are handled securely by Razorpay — we never see or store your card details.",
  ] },
];

export default function About() {
  return (
    <LegalPageLayout badge="About" title="Build software by having a conversation." subtitle="We're making it possible for anyone to turn an idea into a working web app in minutes." sections={SECTIONS}
      ctaTitle="Questions or feedback?" ctaText="We read every message and usually reply within one business day." />
  );
}
